// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

/**
 * OAuth Client App Properties
 */
export type AppBody = {
    category: CharacterString150;
    description: CharacterString255;
    glyphIcon?: CharacterString150;
    homepageURL: CharacterStringHomepageUrl;
    iconURL?: CharacterStringSecureUrl;
    id: CharacterStringUuid;
    name: CharacterString255;
    target?: TargetEnum;
};

/**
 * A list of allowed app categories
 */
export type AppCategoriesBody = {
    /**
     * an array of app category strings
     */
    categories: Array<string>;
};

/**
 * A list of appBody
 */
export type AppListBody = {
    /**
     * an array of appBody
     */
    items: Array<AppBody>;
};

/**
 * Accessability of the BusinessPartner to Identities from its Domain
 */
export enum BusinessPartnerAccessabilityEnum {
    REQUEST_TO_JOIN = 'requestToJoin',
    INVITE_ONLY = 'inviteOnly'
}

/**
 * BusinessPartner Properties
 */
export type BusinessPartnerBody = {
    accessability: BusinessPartnerAccessabilityEnum;
    /**
     * Archived status of the BusinessPartner.  Archive is required prior to delete, as part of a two step delete.
     */
    archived: boolean;
    /**
     * Business Partner created at timestamp
     */
    createdAt: string;
    extId: CharacterStringUrn;
    iconURL?: CharacterStringSecureUrl;
    id: CharacterStringUuid;
    /**
     * Business Partner last modified at timestamp
     */
    modifiedAt: string;
    name: CharacterString255;
    ownerIdentityId: CharacterStringUuid;
    parentBusinessPartnerId?: CharacterStringUuid;
    trn: CharacterStringUrn;
    type: CharacterStringType;
};

/**
 * A list of businessPartnerBody
 */
export type BusinessPartnerListBody = {
    /**
     * an array of businessPartnerBody
     */
    items: Array<BusinessPartnerBody>;
};

/**
 * BusinessPartner Properties
 */
export type BusinessPartnerPatchBody = {
    accessability?: BusinessPartnerAccessabilityEnum;
};

/**
 * BusinessPartner Properties
 */
export type BusinessPartnerPostBody = {
    accessability: BusinessPartnerAccessabilityEnum;
    /**
     * Archived status of the BusinessPartner.  Archive is required prior to delete, as part of a two step delete.
     */
    archived?: boolean;
    extId: CharacterStringUrn;
    name: CharacterString255;
    ownerIdentityId: CharacterStringUuid;
    parentBusinessPartnerId?: CharacterStringUuid;
    type: CharacterStringType;
};

/**
 * BusinessPartner Properties
 */
export type BusinessPartnerWithCurrentIdentityInfoBody = {
    accessability: BusinessPartnerAccessabilityEnum;
    /**
     * Archived status of the BusinessPartner.   Archive is required prior to delete, as part of a two step delete.
     */
    archived: boolean;
    /**
     * Business Partner created at timestamp
     */
    createdAt: string;
    extId: CharacterStringUrn;
    iconURL?: CharacterStringSecureUrl;
    id: CharacterStringUuid;
    /**
     * Is the current Identity the owner of this BusinessPartner
     */
    isOwner?: boolean;
    /**
     * Is the current Identity realated because the BusinessPartner has a verified domain matching the Identity?
     */
    isSameDomain?: boolean;
    /**
     * Business Partner last modified at timestamp
     */
    modifiedAt: string;
    name: CharacterString255;
    ownerIdentityId: CharacterStringUuid;
    parentBusinessPartnerId?: CharacterStringUuid;
    requestToJoin?: RequestToJoinBody;
    trn: CharacterStringUrn;
    type: CharacterStringType;
    user?: UserBody;
};

/**
 * A list of businessPartnerWithCurrentIdentityInfoBody
 */
export type BusinessPartnerWithCurrentIdentityInfoListBody = {
    /**
     * an array of businessPartnerWithCurrentIdentityInfoBody
     */
    items: Array<BusinessPartnerWithCurrentIdentityInfoBody>;
};

/**
 * string of at most 150 characters
 */
export type CharacterString150 = string;

/**
 * string of at most 255 characters
 */
export type CharacterString255 = string;

export type CharacterStringBcp47 = string;

export type CharacterStringClientId = string;

export type CharacterStringDomain = string;

export type CharacterStringEmail = string;

export type CharacterStringHomepageUrl = string;

export type CharacterStringHomepageUrlOrEmpty = string | string;

export type CharacterStringSecureUrl = string;

export type CharacterStringType = string;

export type CharacterStringUrn = string;

/**
 * a Universally Unique IDentifier in conformance with IETF RFC 4122
 */
export type CharacterStringUuid = string;

/**
 * OAuth Client Properties
 */
export type ClientBody = {
    OAuthConfig: ClientOAuthConfig;
    appPolicy: CharacterString150;
    authnPolicy?: CharacterString150;
    businessPartnerId: CharacterStringUuid;
    clientId: CharacterStringClientId;
    /**
     * OAuth 2.0 Client Secret.
     */
    clientSecret: string;
    /**
     * client created at timestamp
     */
    createdAt: string;
    description: CharacterString255;
    effectiveOAuthConfig?: ClientOAuthConfig;
    homepageURL?: CharacterStringHomepageUrl;
    iconURL?: CharacterStringSecureUrl;
    id: CharacterStringUuid;
    /**
     * client  last modified at timestamp
     */
    modifiedAt: string;
    name: CharacterString255;
};

/**
 * A list of clientBody
 */
export type ClientListBody = {
    /**
     * an array of clientBody
     */
    items: Array<ClientBody>;
};

/**
 * OAuth Client Configuration
 */
export type ClientOAuthConfig = {
    /**
     * List of requested grants, granted by the appPolicy (authorization_code, implicit, refresh, client_credentials, device_authorization, token_exchange)
     */
    grants: Array<ClientOAuthGrantEnum>;
    /**
     * List of requested policies, granted within the appPolicy (iso15143-4, long_expiry, rs256, bypass_approval)
     */
    policies?: Array<string>;
    /**
     * List of legal redirect URL for Authorization Code flow
     */
    redirectURLs: Array<string>;
    /**
     * List of requirements, stated by the appPolicy (pkce)
     */
    require?: Array<ClientOAuthRequireEnum>;
    /**
     * List of requested scopes, granted within the appPolicy
     */
    scopes: Array<string>;
};

/**
 * OAuth client grant options
 */
export enum ClientOAuthGrantEnum {
    '*' = '*',
    AUTHORIZATION_CODE = 'authorization_code',
    IMPLICIT = 'implicit',
    REFRESH = 'refresh',
    CLIENT_CREDENTIALS = 'client_credentials',
    DEVICE_AUTHORIZATION = 'device_authorization',
    TOKEN_EXCHANGE = 'token_exchange'
}

/**
 * OAuth client require options
 */
export enum ClientOAuthRequireEnum {
    '*' = '*',
    PKCE = 'pkce'
}

/**
 * Client Properties
 */
export type ClientPatchBody = {
    OAuthConfig?: ClientOAuthConfig;
    appPolicy?: CharacterString150;
    authnPolicy?: CharacterString150;
    description?: CharacterString255;
    /**
     * Generate a new secret.
     */
    generateSecret?: boolean;
    homepageURL?: CharacterStringHomepageUrlOrEmpty;
    name?: CharacterString255;
};

/**
 * OAuth Client Properties
 */
export type ClientPostBody = {
    OAuthConfig: ClientOAuthConfig;
    appPolicy: CharacterString150;
    authnPolicy?: CharacterString150;
    clientId?: CharacterStringClientId;
    description: CharacterString255;
    homepageURL?: CharacterStringHomepageUrl;
    name: CharacterString255;
};

/**
 * Context information about the current session
 */
export type ContextBody = {
    businessPartner?: ContextBusinessPartner;
    identity?: ContextIdentity;
    profile?: ContextProfile;
    /**
     * DEPRECATED, use profile instead: session profile id, not provided if the session has no profile which is valid in some applications.
     */
    profileId?: string;
    serviceProvider?: ContextServiceProvider;
    topconSupport?: ContextTopconSupport;
};

export type ContextBusinessPartner = {
    id: CharacterStringUuid;
    name: CharacterString255;
    trn: CharacterStringUrn;
    type: CharacterStringType;
};

export type ContextIdentity = {
    email: CharacterStringEmail;
    id: CharacterStringUuid;
    trn: CharacterStringUrn;
};

/**
 * present if current session has a profile.  no profile is valid for some applications.
 */
export type ContextProfile = {
    /**
     * True if the user can switch profiles; omitted otherwise.
     */
    canSwitch?: boolean;
    description: CharacterString255;
    displayName: CharacterString255;
    id: CharacterString255;
};

/**
 * present if current session is by a Service Provider (dealer)
 */
export type ContextServiceProvider = {
    id: CharacterStringUuid;
    name: CharacterString255;
    /**
     * terms of the service agreement
     */
    terms: string;
    trn: CharacterStringUrn;
    type: CharacterStringType;
};

/**
 * present if current session is by Topcon support
 */
export type ContextTopconSupport = {
    id: CharacterStringUuid;
    name: CharacterString255;
    /**
     * the profile which enabled the support session
     */
    profileId: string;
    trn: CharacterStringUrn;
    type: CharacterStringType;
};

/**
 * Domain Properties
 */
export type DomainBody = {
    businessPartnerId: CharacterStringUuid;
    /**
     * Domain created at timestamp
     */
    createdAt: string;
    id: CharacterStringUuid;
    identityProviderId?: CharacterStringUuid;
    /**
     * Domain last modified at timestamp
     */
    modifiedAt: string;
    name: CharacterStringDomain;
    proofTXT: CharacterString255;
    verified: boolean;
    verifyErrors?: Array<string>;
};

/**
 * A list of domainBody
 */
export type DomainListBody = {
    /**
     * an array of domainBody
     */
    items: Array<DomainBody>;
};

/**
 * Domain Properties
 */
export type DomainPatchBody = {
    identityProviderId?: CharacterStringUuid;
};

/**
 * Domain Properties
 */
export type DomainPostBody = {
    identityProviderId?: CharacterStringUuid;
    name: CharacterStringDomain;
};

/**
 * ExternalIdentity Properties
 */
export type ExternalIdentityBody = {
    email: CharacterStringEmail;
    extId: CharacterStringUrn;
    firstName: CharacterString255;
    lastName: CharacterString255;
    preferredLanguage?: CharacterStringBcp47;
    realm: CharacterString255;
};

/**
 * ExternalIdentity Properties
 */
export type ExternalIdentityPostBody = {
    email: CharacterStringEmail;
    /**
     * Optional, default false.  true authorizes changes to an existing email address.
     */
    emailVerified?: boolean;
    extId: CharacterStringUrn;
    firstName: CharacterString255;
    lastName: CharacterString255;
    preferredLanguage?: CharacterStringBcp47;
    realm: CharacterString255;
    /**
     * Unarchive the Identity if it is currently archived
     */
    unarchive?: boolean;
};

/**
 * Identity Properties
 */
export type IdentityBody = {
    /**
     * Archived status of the Identity.  Archive is required prior to delete, as part of a two step delete.  Archived is *not* in sync with any upstream IDP archive.
     */
    archived: boolean;
    /**
     * Identity created at timestamp
     */
    createdAt: string;
    email: CharacterStringEmail;
    /**
     * IDP handles for this Identity, omitted unless requested for get and page requests
     */
    externalIdentities?: Array<ExternalIdentityBody>;
    firstName: CharacterString255;
    id: CharacterStringUuid;
    lastName: CharacterString255;
    /**
     * Identity last modified at timestamp
     */
    modifiedAt: string;
    preferredLanguage?: CharacterStringBcp47;
    trn: CharacterStringUrn;
};

/**
 * A list of identityBody
 */
export type IdentityListBody = {
    /**
     * an array of identityBody
     */
    items: Array<IdentityBody>;
};

/**
 * Identity Patch Properties
 */
export type IdentityPatchBody = {
    /**
     * Archived status of the Identity.  Archive is required prior to delete, as part of a two step delete.  Archived is *not* in sync with any upstream IDP archive.
     */
    archived?: boolean;
    preferredLanguage?: CharacterStringBcp47;
};

/**
 * IdentityProvider Properties
 */
export type IdentityProviderBody = {
    OIDCConfig?: IdpOidcConfig;
    SAMLConfig?: IdpSamlConfig;
    businessPartnerId: CharacterStringUuid;
    /**
     * IDP created at timestamp
     */
    createdAt: string;
    fieldMappings: IdpFieldMappings;
    id: CharacterStringUuid;
    metaDataURL?: CharacterStringSecureUrl;
    /**
     * IDP last modified at timestamp
     */
    modifiedAt: string;
    name: CharacterString255;
    realm: CharacterStringDomain;
    redirectURL?: CharacterStringSecureUrl;
};

/**
 * A list of identityProvider
 */
export type IdentityProviderListBody = {
    /**
     * an array of identityProvider
     */
    items: Array<IdentityProviderBody>;
};

/**
 * IdentityProvider Properties
 */
export type IdentityProviderPatchBody = {
    OIDCConfig?: IdpOidcConfig;
    SAMLConfig?: IdpSamlConfig;
    fieldMappings?: IdpFieldMappings;
    name?: CharacterString255;
};

/**
 * IdentityProvider Properties
 */
export type IdentityProviderPostBody = {
    OIDCConfig?: IdpOidcConfig;
    OIDCConfigWK?: IdpOidcConfigWk;
    SAMLConfig?: IdpSamlConfig;
    fieldMappings?: IdpFieldMappings;
    name: CharacterString255;
    realm: CharacterStringDomain;
};

/**
 * Mappings from upstream token claims to the downstream token claims
 */
export type IdpFieldMappings = {
    /**
     * Upstream email claim
     */
    email?: string;
    /**
     * Upstream firstname claim
     */
    firstName?: string;
    /**
     * Upstream lastname claim
     */
    lastName?: string;
    /**
     * Upstream preferredLanguage claim
     */
    preferredLanguage?: string;
};

/**
 * OIDC Configuration
 */
export type IdpOidcConfig = {
    /**
     * List of JWT algorithms allowed to sign ID tokens
     */
    algorithms?: Array<string>;
    authURL: CharacterStringSecureUrl;
    /**
     * OAuth 2.0 Client ID
     */
    clientId: string;
    /**
     * OAuth 2.0 Client Secret
     */
    clientSecret: string;
    issuerURL: CharacterStringSecureUrl;
    jwksURL: CharacterStringSecureUrl;
    tokenURL: CharacterStringSecureUrl;
    userInfoURL: CharacterStringSecureUrl;
};

/**
 * OIDC Well Known Configuration
 */
export type IdpOidcConfigWk = {
    /**
     * OAuth 2.0 Client ID
     */
    clientId: string;
    /**
     * OAuth 2.0 Client Secret
     */
    clientSecret: string;
    wellKnownConfigurationURL: CharacterStringSecureUrl;
};

/**
 * SAML Configuration
 */
export type IdpSamlConfig = {
    metaDataURL: CharacterStringSecureUrl;
};

/**
 * InviteToJoin Properties
 */
export type InviteToJoinBody = {
    businessPartner?: BusinessPartnerBody;
    businessPartnerId: CharacterStringUuid;
    /**
     * Invite to Join created at timestamp
     */
    createdAt: string;
    email: CharacterStringEmail;
    id: CharacterStringUuid;
    /**
     * Invite to Join last modified at timestamp
     */
    modifiedAt: string;
    /**
     * The profiles the invited identity will adopt once they accept.
     */
    profileIds: Array<string>;
};

/**
 * A list of inviteToJoinBody
 */
export type InviteToJoinListBody = {
    /**
     * an array of inviteToJoinBody
     */
    items: Array<InviteToJoinBody>;
};

/**
 * InviteToJoin Properties
 */
export type InviteToJoinPatchBody = {
    /**
     * The profiles the invited identity will adopt once they accept.
     */
    profileIds?: Array<string>;
};

/**
 * InviteToJoin Properties
 */
export type InviteToJoinPostBody = {
    email: CharacterStringEmail;
    /**
     * The profiles the invited identity will adopt once they accept.
     */
    profileIds: Array<string>;
};

/**
 * The virtual owner user of the business partner
 */
export type OwnerBody = {
    businessPartnerId: CharacterStringUuid;
    identity: IdentityBody;
    identityId: CharacterStringUuid;
    profileIds: Array<string>;
};

/**
 * A paginated list of identityBody
 */
export type PaginatedIdentityListBody = {
    /**
     * an array of identityBody
     */
    items: Array<IdentityBody>;
    /**
     * current limit query value
     */
    limit: number;
    /**
     * current page query value
     */
    page: number;
    /**
     * total count
     */
    total: number;
};

/**
 * Profile
 */
export type ProfileBody = {
    /**
     * translation template for the profile description
     */
    description: string;
    /**
     * translation template for the profile display name
     */
    displayName: string;
    /**
     * grouping of profiles by focus industry, 2nd dot of the 3-dot profile scheme
     */
    focusIndustry: string;
    /**
     * 3rd dot of the 3-dot profile scheme
     */
    name: string;
    /**
     * 3-dot scheme profile id used for the User object 'profileId' field
     */
    profileId: string;
};

/**
 * A list of profiles available for the current BusinessPartner
 */
export type ProfileListBody = {
    /**
     * an array of profileBody
     */
    items: Array<ProfileBody>;
};

/**
 * RequestToJoin Properties
 */
export type RequestToJoinBody = {
    businessPartner?: BusinessPartnerBody;
    businessPartnerId: CharacterStringUuid;
    /**
     * Request to Join created at timestamp
     */
    createdAt: string;
    id: CharacterStringUuid;
    identity?: IdentityBody;
    identityId: CharacterStringUuid;
    /**
     * Request to Join last modified at timestamp
     */
    modifiedAt: string;
    /**
     * Information on who can approve or reject this request. Provided when getting a requestToJoin from the context of an identity.
     */
    reviewers?: Array<ReviewerBody>;
};

/**
 * A list of requestToJoinBody
 */
export type RequestToJoinListBody = {
    /**
     * an array of requestToJoinBody
     */
    items: Array<RequestToJoinBody>;
};

/**
 * RequestToJoin Properties
 */
export type RequestToJoinPostBody = {
    businessPartnerId: CharacterStringUuid;
};

/**
 * A reviewer who can approve or reject a RequestToJoin
 */
export type ReviewerBody = {
    /**
     * Email address of the reviewer
     */
    email: string;
};

/**
 * A list of role
 */
export type RoleListBody = {
    /**
     * an array of role string
     */
    items: Array<string>;
};

/**
 * Support token response
 */
export type SupportTokenBody = {
    /**
     * Base64-encoded encrypted token
     */
    token: string;
};

/**
 * Request to create a support token for Topcon support
 */
export type SupportTokenPostBody = {
    identityId: CharacterStringUuid;
    /**
     * Reason for support access
     */
    reason: string;
    /**
     * Support ticket or case number
     */
    ticket: string;
};

/**
 * target options for opening linked documents
 */
export enum TargetEnum {
    _BLANK = '_blank'
}

/**
 * User Properties
 */
export type UserBody = {
    businessPartner?: BusinessPartnerBody;
    businessPartnerId: CharacterStringUuid;
    /**
     * User created at timestamp
     */
    createdAt: string;
    id: CharacterStringUuid;
    identity?: IdentityBody;
    identityId: CharacterStringUuid;
    /**
     * User last modified at timestamp
     */
    modifiedAt: string;
    profileIds: Array<string>;
};

/**
 * A list of userBody
 */
export type UserListBody = {
    /**
     * an array of userBody
     */
    items: Array<UserBody>;
};

/**
 * A list of userBody with an ownerBody
 */
export type UserOwnerListBody = {
    /**
     * an array of userBody
     */
    items: Array<UserBody>;
    owner: OwnerBody;
};

/**
 * User Properties
 */
export type UserPatchBody = {
    profileIds?: Array<string>;
};

/**
 * User Properties
 */
export type UserPostBody = {
    identityId: CharacterStringUuid;
    profileIds: Array<string>;
};

export type GetV1BusinessPartnerCurrentData = {
    body?: never;
    path?: never;
    query?: {
        icon?: string;
    };
    url: '/v1/businessPartner/current';
};

export type GetV1BusinessPartnerCurrentErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1BusinessPartnerCurrentResponses = {
    /**
     * Successful Response
     */
    200: BusinessPartnerBody;
};

export type GetV1BusinessPartnerCurrentResponse = GetV1BusinessPartnerCurrentResponses[keyof GetV1BusinessPartnerCurrentResponses];

export type PutV1BusinessPartnerCurrentData = {
    /**
     * TODO
     */
    body: BusinessPartnerPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path?: never;
    query?: never;
    url: '/v1/businessPartner/current';
};

export type PutV1BusinessPartnerCurrentErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1BusinessPartnerCurrentResponses = {
    /**
     * Successful Response
     */
    200: BusinessPartnerBody;
};

export type PutV1BusinessPartnerCurrentResponse = PutV1BusinessPartnerCurrentResponses[keyof PutV1BusinessPartnerCurrentResponses];

export type GetV1BusinessPartnerCurrentDivisionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/businessPartner/current/divisions';
};

export type GetV1BusinessPartnerCurrentDivisionsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1BusinessPartnerCurrentDivisionsResponses = {
    /**
     * Successful Response
     */
    200: BusinessPartnerWithCurrentIdentityInfoListBody;
};

export type GetV1BusinessPartnerCurrentDivisionsResponse = GetV1BusinessPartnerCurrentDivisionsResponses[keyof GetV1BusinessPartnerCurrentDivisionsResponses];

export type DeleteV1BusinessPartnerCurrentIconData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/businessPartner/current/icon';
};

export type DeleteV1BusinessPartnerCurrentIconErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1BusinessPartnerCurrentIconResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteV1BusinessPartnerCurrentIconResponse = DeleteV1BusinessPartnerCurrentIconResponses[keyof DeleteV1BusinessPartnerCurrentIconResponses];

export type PostV1BusinessPartnerCurrentIconData = {
    /**
     * TODO
     */
    body: {
        thumbnail: Blob | File;
    };
    path?: never;
    query?: never;
    url: '/v1/businessPartner/current/icon';
};

export type PostV1BusinessPartnerCurrentIconErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
};

export type PostV1BusinessPartnerCurrentIconResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1BusinessPartnerCurrentProfilesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/businessPartner/current/profiles';
};

export type GetV1BusinessPartnerCurrentProfilesErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type GetV1BusinessPartnerCurrentProfilesResponses = {
    /**
     * Successful Response
     */
    200: ProfileListBody;
};

export type GetV1BusinessPartnerCurrentProfilesResponse = GetV1BusinessPartnerCurrentProfilesResponses[keyof GetV1BusinessPartnerCurrentProfilesResponses];

export type GetV1BusinessPartnerCurrentSuggestIdentitiesData = {
    body?: never;
    path?: never;
    query?: {
        suggest?: string;
    };
    url: '/v1/businessPartner/current/suggestIdentities';
};

export type GetV1BusinessPartnerCurrentSuggestIdentitiesErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1BusinessPartnerCurrentSuggestIdentitiesResponses = {
    /**
     * Successful Response
     */
    200: IdentityListBody;
};

export type GetV1BusinessPartnerCurrentSuggestIdentitiesResponse = GetV1BusinessPartnerCurrentSuggestIdentitiesResponses[keyof GetV1BusinessPartnerCurrentSuggestIdentitiesResponses];

export type GetV1BusinessPartnerCurrentWithCurrentIdentityInfoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/businessPartner/current/withCurrentIdentityInfo';
};

export type GetV1BusinessPartnerCurrentWithCurrentIdentityInfoErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponses = {
    /**
     * Successful Response
     */
    200: BusinessPartnerWithCurrentIdentityInfoBody;
};

export type GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponse = GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponses[keyof GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponses];

export type GetV1ContextData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/context';
};

export type GetV1ContextErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1ContextResponses = {
    /**
     * Successful Response
     */
    200: ContextBody;
};

export type GetV1ContextResponse = GetV1ContextResponses[keyof GetV1ContextResponses];

export type PostV1DomainData = {
    /**
     * TODO
     */
    body: DomainPostBody;
    path?: never;
    query?: never;
    url: '/v1/domain';
};

export type PostV1DomainErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1DomainResponses = {
    /**
     * Created
     */
    201: DomainBody;
};

export type PostV1DomainResponse = PostV1DomainResponses[keyof PostV1DomainResponses];

export type DeleteV1DomainByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/domain/{id}';
};

export type DeleteV1DomainByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1DomainByIdResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1DomainByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/domain/{id}';
};

export type GetV1DomainByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1DomainByIdResponses = {
    /**
     * Successful Response
     */
    200: DomainBody;
};

export type GetV1DomainByIdResponse = GetV1DomainByIdResponses[keyof GetV1DomainByIdResponses];

export type PutV1DomainByIdData = {
    /**
     * TODO
     */
    body: DomainPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/domain/{id}';
};

export type PutV1DomainByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1DomainByIdResponses = {
    /**
     * Successful Response
     */
    200: DomainBody;
};

export type PutV1DomainByIdResponse = PutV1DomainByIdResponses[keyof PutV1DomainByIdResponses];

export type PutV1DomainByIdVerifyData = {
    body?: never;
    headers?: {
        'If-Match'?: string;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/domain/{id}/verify';
};

export type PutV1DomainByIdVerifyErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1DomainByIdVerifyResponses = {
    /**
     * Successful Response
     */
    200: DomainBody;
};

export type PutV1DomainByIdVerifyResponse = PutV1DomainByIdVerifyResponses[keyof PutV1DomainByIdVerifyResponses];

export type GetV1DomainsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/domains';
};

export type GetV1DomainsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1DomainsResponses = {
    /**
     * Successful Response
     */
    200: DomainListBody;
};

export type GetV1DomainsResponse = GetV1DomainsResponses[keyof GetV1DomainsResponses];

export type GetV1IdentitiesData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        limit?: number;
        /**
         * **example query**: *?filter[email][operator]=value*<br><br> **valid operators:** *eq*, *startswith*
         */
        'filter[email]'?: {
            [key: string]: unknown;
        };
        /**
         * **example query**: *?filter[name][operator]=value*<br><br> **valid operators:** *eq*, *startswith*
         */
        'filter[name]'?: {
            [key: string]: unknown;
        };
        /**
         * **example query:** *?sort[field]=value*<br><br>**valid values:** *asc* *desc*<br><br>**valid fields:** *id* *email* *firstName* *lastName*
         */
        sort?: {
            [key: string]: unknown;
        };
        search?: string;
    };
    url: '/v1/identities';
};

export type GetV1IdentitiesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
};

export type GetV1IdentitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedIdentityListBody;
};

export type GetV1IdentitiesResponse = GetV1IdentitiesResponses[keyof GetV1IdentitiesResponses];

export type GetV1IdentityCurrentData = {
    body?: never;
    path?: never;
    query?: {
        external?: string;
    };
    url: '/v1/identity/current';
};

export type GetV1IdentityCurrentErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1IdentityCurrentResponses = {
    /**
     * Successful Response
     */
    200: IdentityBody;
};

export type GetV1IdentityCurrentResponse = GetV1IdentityCurrentResponses[keyof GetV1IdentityCurrentResponses];

export type PutV1IdentityCurrentData = {
    /**
     * TODO
     */
    body: IdentityPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path?: never;
    query?: never;
    url: '/v1/identity/current';
};

export type PutV1IdentityCurrentErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1IdentityCurrentResponses = {
    /**
     * Successful Response
     */
    200: IdentityBody;
};

export type PutV1IdentityCurrentResponse = PutV1IdentityCurrentResponses[keyof PutV1IdentityCurrentResponses];

export type GetV1IdentityCurrentBusinessPartnersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/identity/current/businessPartners';
};

export type GetV1IdentityCurrentBusinessPartnersErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1IdentityCurrentBusinessPartnersResponses = {
    /**
     * Successful Response
     */
    200: BusinessPartnerWithCurrentIdentityInfoListBody;
};

export type GetV1IdentityCurrentBusinessPartnersResponse = GetV1IdentityCurrentBusinessPartnersResponses[keyof GetV1IdentityCurrentBusinessPartnersResponses];

export type DeleteV1IdentityCurrentInviteToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identity/current/inviteToJoin/{id}';
};

export type DeleteV1IdentityCurrentInviteToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type DeleteV1IdentityCurrentInviteToJoinByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteV1IdentityCurrentInviteToJoinByIdResponse = DeleteV1IdentityCurrentInviteToJoinByIdResponses[keyof DeleteV1IdentityCurrentInviteToJoinByIdResponses];

export type PostV1IdentityCurrentInviteToJoinByIdAcceptData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identity/current/inviteToJoin/{id}/accept';
};

export type PostV1IdentityCurrentInviteToJoinByIdAcceptErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1IdentityCurrentInviteToJoinByIdAcceptResponses = {
    /**
     * Created
     */
    201: UserBody;
};

export type PostV1IdentityCurrentInviteToJoinByIdAcceptResponse = PostV1IdentityCurrentInviteToJoinByIdAcceptResponses[keyof PostV1IdentityCurrentInviteToJoinByIdAcceptResponses];

export type GetV1IdentityCurrentInvitesToJoinData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/identity/current/invitesToJoin';
};

export type GetV1IdentityCurrentInvitesToJoinErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1IdentityCurrentInvitesToJoinResponses = {
    /**
     * Successful Response
     */
    200: InviteToJoinListBody;
};

export type GetV1IdentityCurrentInvitesToJoinResponse = GetV1IdentityCurrentInvitesToJoinResponses[keyof GetV1IdentityCurrentInvitesToJoinResponses];

export type DeleteV1IdentityCurrentRequestToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identity/current/requestToJoin/{id}';
};

export type DeleteV1IdentityCurrentRequestToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1IdentityCurrentRequestToJoinByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteV1IdentityCurrentRequestToJoinByIdResponse = DeleteV1IdentityCurrentRequestToJoinByIdResponses[keyof DeleteV1IdentityCurrentRequestToJoinByIdResponses];

export type GetV1IdentityCurrentRequestToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identity/current/requestToJoin/{id}';
};

export type GetV1IdentityCurrentRequestToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1IdentityCurrentRequestToJoinByIdResponses = {
    /**
     * Successful Response
     */
    200: RequestToJoinBody;
};

export type GetV1IdentityCurrentRequestToJoinByIdResponse = GetV1IdentityCurrentRequestToJoinByIdResponses[keyof GetV1IdentityCurrentRequestToJoinByIdResponses];

export type GetV1IdentityCurrentRequestsToJoinData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/identity/current/requestsToJoin';
};

export type GetV1IdentityCurrentRequestsToJoinErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1IdentityCurrentRequestsToJoinResponses = {
    /**
     * Successful Response
     */
    200: RequestToJoinListBody;
};

export type GetV1IdentityCurrentRequestsToJoinResponse = GetV1IdentityCurrentRequestsToJoinResponses[keyof GetV1IdentityCurrentRequestsToJoinResponses];

export type DeleteV1IdentityCurrentUserByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identity/current/user/{id}';
};

export type DeleteV1IdentityCurrentUserByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type DeleteV1IdentityCurrentUserByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteV1IdentityCurrentUserByIdResponse = DeleteV1IdentityCurrentUserByIdResponses[keyof DeleteV1IdentityCurrentUserByIdResponses];

export type GetV1IdentityCurrentUsersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/identity/current/users';
};

export type GetV1IdentityCurrentUsersErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1IdentityCurrentUsersResponses = {
    /**
     * Successful Response
     */
    200: UserListBody;
};

export type GetV1IdentityCurrentUsersResponse = GetV1IdentityCurrentUsersResponses[keyof GetV1IdentityCurrentUsersResponses];

export type PostV1IdentityProviderData = {
    /**
     * TODO
     */
    body: IdentityProviderPostBody;
    path?: never;
    query?: never;
    url: '/v1/identityProvider';
};

export type PostV1IdentityProviderErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1IdentityProviderResponses = {
    /**
     * Created
     */
    201: IdentityProviderBody;
};

export type PostV1IdentityProviderResponse = PostV1IdentityProviderResponses[keyof PostV1IdentityProviderResponses];

export type DeleteV1IdentityProviderByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identityProvider/{id}';
};

export type DeleteV1IdentityProviderByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1IdentityProviderByIdResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1IdentityProviderByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identityProvider/{id}';
};

export type GetV1IdentityProviderByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1IdentityProviderByIdResponses = {
    /**
     * Successful Response
     */
    200: IdentityProviderBody;
};

export type GetV1IdentityProviderByIdResponse = GetV1IdentityProviderByIdResponses[keyof GetV1IdentityProviderByIdResponses];

export type PutV1IdentityProviderByIdData = {
    /**
     * TODO
     */
    body: IdentityProviderPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/identityProvider/{id}';
};

export type PutV1IdentityProviderByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1IdentityProviderByIdResponses = {
    /**
     * Successful Response
     */
    200: IdentityProviderBody;
};

export type PutV1IdentityProviderByIdResponse = PutV1IdentityProviderByIdResponses[keyof PutV1IdentityProviderByIdResponses];

export type GetV1IdentityProvidersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/identityProviders';
};

export type GetV1IdentityProvidersErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1IdentityProvidersResponses = {
    /**
     * Successful Response
     */
    200: IdentityProviderListBody;
};

export type GetV1IdentityProvidersResponse = GetV1IdentityProvidersResponses[keyof GetV1IdentityProvidersResponses];

export type PostV1InviteToJoinData = {
    /**
     * TODO
     */
    body: InviteToJoinPostBody;
    path?: never;
    query?: never;
    url: '/v1/inviteToJoin';
};

export type PostV1InviteToJoinErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1InviteToJoinResponses = {
    /**
     * Created
     */
    201: InviteToJoinBody;
};

export type PostV1InviteToJoinResponse = PostV1InviteToJoinResponses[keyof PostV1InviteToJoinResponses];

export type DeleteV1InviteToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/inviteToJoin/{id}';
};

export type DeleteV1InviteToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1InviteToJoinByIdResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1InviteToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/inviteToJoin/{id}';
};

export type GetV1InviteToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1InviteToJoinByIdResponses = {
    /**
     * Successful Response
     */
    200: InviteToJoinBody;
};

export type GetV1InviteToJoinByIdResponse = GetV1InviteToJoinByIdResponses[keyof GetV1InviteToJoinByIdResponses];

export type PutV1InviteToJoinByIdData = {
    /**
     * TODO
     */
    body: InviteToJoinPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/inviteToJoin/{id}';
};

export type PutV1InviteToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1InviteToJoinByIdResponses = {
    /**
     * Successful Response
     */
    200: InviteToJoinBody;
};

export type PutV1InviteToJoinByIdResponse = PutV1InviteToJoinByIdResponses[keyof PutV1InviteToJoinByIdResponses];

export type GetV1InvitesToJoinData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/invitesToJoin';
};

export type GetV1InvitesToJoinErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1InvitesToJoinResponses = {
    /**
     * Successful Response
     */
    200: InviteToJoinListBody;
};

export type GetV1InvitesToJoinResponse = GetV1InvitesToJoinResponses[keyof GetV1InvitesToJoinResponses];

export type PostV1OauthClientData = {
    /**
     * TODO
     */
    body: ClientPostBody;
    path?: never;
    query?: never;
    url: '/v1/oauthClient';
};

export type PostV1OauthClientErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1OauthClientResponses = {
    /**
     * Created
     */
    201: ClientBody;
};

export type PostV1OauthClientResponse = PostV1OauthClientResponses[keyof PostV1OauthClientResponses];

export type DeleteV1OauthClientByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/oauthClient/{id}';
};

export type DeleteV1OauthClientByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type DeleteV1OauthClientByIdResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1OauthClientByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/oauthClient/{id}';
};

export type GetV1OauthClientByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type GetV1OauthClientByIdResponses = {
    /**
     * Successful Response
     */
    200: ClientBody;
};

export type GetV1OauthClientByIdResponse = GetV1OauthClientByIdResponses[keyof GetV1OauthClientByIdResponses];

export type PutV1OauthClientByIdData = {
    /**
     * TODO
     */
    body: ClientPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/oauthClient/{id}';
};

export type PutV1OauthClientByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1OauthClientByIdResponses = {
    /**
     * Successful Response
     */
    200: ClientBody;
};

export type PutV1OauthClientByIdResponse = PutV1OauthClientByIdResponses[keyof PutV1OauthClientByIdResponses];

export type PostV1OauthClientByIdIconData = {
    /**
     * TODO
     */
    body: {
        thumbnail: Blob | File;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/oauthClient/{id}/icon';
};

export type PostV1OauthClientByIdIconErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
};

export type PostV1OauthClientByIdIconResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1OauthClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/oauthClients';
};

export type GetV1OauthClientsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1OauthClientsResponses = {
    /**
     * Successful Response
     */
    200: ClientListBody;
};

export type GetV1OauthClientsResponse = GetV1OauthClientsResponses[keyof GetV1OauthClientsResponses];

export type GetV1OauthClientsCategoriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/oauthClients/categories';
};

export type GetV1OauthClientsCategoriesErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1OauthClientsCategoriesResponses = {
    /**
     * Successful Response
     */
    200: AppCategoriesBody;
};

export type GetV1OauthClientsCategoriesResponse = GetV1OauthClientsCategoriesResponses[keyof GetV1OauthClientsCategoriesResponses];

export type PostV1RequestToJoinData = {
    /**
     * TODO
     */
    body: RequestToJoinPostBody;
    path?: never;
    query?: never;
    url: '/v1/requestToJoin';
};

export type PostV1RequestToJoinErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1RequestToJoinResponses = {
    /**
     * Created
     */
    201: RequestToJoinBody;
};

export type PostV1RequestToJoinResponse = PostV1RequestToJoinResponses[keyof PostV1RequestToJoinResponses];

export type DeleteV1RequestToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/requestToJoin/{id}';
};

export type DeleteV1RequestToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1RequestToJoinByIdResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetV1RequestToJoinByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/requestToJoin/{id}';
};

export type GetV1RequestToJoinByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1RequestToJoinByIdResponses = {
    /**
     * Successful Response
     */
    200: RequestToJoinBody;
};

export type GetV1RequestToJoinByIdResponse = GetV1RequestToJoinByIdResponses[keyof GetV1RequestToJoinByIdResponses];

export type GetV1RequestsToJoinData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/requestsToJoin';
};

export type GetV1RequestsToJoinErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1RequestsToJoinResponses = {
    /**
     * Successful Response
     */
    200: RequestToJoinListBody;
};

export type GetV1RequestsToJoinResponse = GetV1RequestsToJoinResponses[keyof GetV1RequestsToJoinResponses];

export type GetV1RolesCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/roles/current';
};

export type GetV1RolesCurrentErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1RolesCurrentResponses = {
    /**
     * Successful Response
     */
    200: RoleListBody;
};

export type GetV1RolesCurrentResponse = GetV1RolesCurrentResponses[keyof GetV1RolesCurrentResponses];

export type PostV1SupportTokenData = {
    /**
     * TODO
     */
    body: SupportTokenPostBody;
    path?: never;
    query?: never;
    url: '/v1/supportToken';
};

export type PostV1SupportTokenErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type PostV1SupportTokenResponses = {
    /**
     * Created
     */
    201: SupportTokenBody;
};

export type PostV1SupportTokenResponse = PostV1SupportTokenResponses[keyof PostV1SupportTokenResponses];

export type PostV1UserData = {
    /**
     * TODO
     */
    body: UserPostBody;
    path?: never;
    query?: never;
    url: '/v1/user';
};

export type PostV1UserErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PostV1UserResponses = {
    /**
     * Created
     */
    201: UserBody;
};

export type PostV1UserResponse = PostV1UserResponses[keyof PostV1UserResponses];

export type GetV1UserCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/user/current';
};

export type GetV1UserCurrentErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1UserCurrentResponses = {
    /**
     * Successful Response
     */
    200: UserBody;
};

export type GetV1UserCurrentResponse = GetV1UserCurrentResponses[keyof GetV1UserCurrentResponses];

export type GetV1UserCurrentAppsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/user/current/apps';
};

export type GetV1UserCurrentAppsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type GetV1UserCurrentAppsResponses = {
    /**
     * Successful Response
     */
    200: AppListBody;
};

export type GetV1UserCurrentAppsResponse = GetV1UserCurrentAppsResponses[keyof GetV1UserCurrentAppsResponses];

export type GetV1UserCurrentOauthClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/user/current/oauthClients';
};

export type GetV1UserCurrentOauthClientsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type GetV1UserCurrentOauthClientsResponses = {
    /**
     * Successful Response
     */
    200: AppListBody;
};

export type GetV1UserCurrentOauthClientsResponse = GetV1UserCurrentOauthClientsResponses[keyof GetV1UserCurrentOauthClientsResponses];

export type DeleteV1UserByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/user/{id}';
};

export type DeleteV1UserByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteV1UserByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteV1UserByIdResponse = DeleteV1UserByIdResponses[keyof DeleteV1UserByIdResponses];

export type GetV1UserByIdData = {
    body?: never;
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/user/{id}';
};

export type GetV1UserByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetV1UserByIdResponses = {
    /**
     * Successful Response
     */
    200: UserBody;
};

export type GetV1UserByIdResponse = GetV1UserByIdResponses[keyof GetV1UserByIdResponses];

export type PutV1UserByIdData = {
    /**
     * TODO
     */
    body: UserPatchBody;
    headers?: {
        'If-Match'?: string;
    };
    path: {
        /**
         * TODO
         */
        id: string;
    };
    query?: never;
    url: '/v1/user/{id}';
};

export type PutV1UserByIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Conflict
     */
    409: unknown;
};

export type PutV1UserByIdResponses = {
    /**
     * Successful Response
     */
    200: UserBody;
};

export type PutV1UserByIdResponse = PutV1UserByIdResponses[keyof PutV1UserByIdResponses];

export type GetV1UsersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v1/users';
};

export type GetV1UsersErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
};

export type GetV1UsersResponses = {
    /**
     * Successful Response
     */
    200: UserOwnerListBody;
};

export type GetV1UsersResponse = GetV1UsersResponses[keyof GetV1UsersResponses];
